import { forwardRef } from "react";
import { Snackbar, SnackbarCloseReason } from "@mui/material";
import MuiAlert, { AlertProps, AlertColor } from "@mui/material/Alert";
import cx from "classnames";

interface CommonProps {
  action?: React.ReactNode;
  className?: string;
  message: string;
  onClose: () => void;
  open: boolean;
  severity: AlertColor;
}

type ConditionalProps =
  | { autoHideDuration?: never; autoHideOff?: boolean }
  | {
      autoHideDuration?: number;
      autoHideOff?: never;
    };

export type CustomizedSnackbarProps = CommonProps & ConditionalProps;

const Alert = forwardRef<HTMLDivElement, AlertProps>((props: AlertProps, ref) => (
  <MuiAlert elevation={6} ref={ref} variant='standard' {...props} />
));

function CustomizedSnackbar(props: CustomizedSnackbarProps) {
  const { action, autoHideDuration, autoHideOff, className, message, onClose, open, severity } = props;

  const handleClose = (event: Event | React.SyntheticEvent<any, Event>, reason?: SnackbarCloseReason): void => {
    if (reason === "clickaway") {
      return;
    }

    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideOff ? undefined : (autoHideDuration ?? 6000)}
      onClose={handleClose}
      className={cx(className)}
    >
      <Alert onClose={handleClose} severity={severity} action={action}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default CustomizedSnackbar;
